module.exports = __webpack_public_path__ + "img/logo-blue.5d3bed27.svg";